export default m => m / 352.77777777777777
